class VgBuyPill extends HTMLElement {
  connectedCallback() {
    this._variantId = this.dataset.variantId;
    this._lineKey = null;
    this._qty = 0;
    this._baseQty = 0;

    this._addBtn = this.querySelector('.vg-product-card__add');
    this._qtyEl = this.querySelector('.vg-product-card__stepper-qty');
    this._minusBtn = this.querySelector('[data-action="minus"]');
    this._plusBtn = this.querySelector('[data-action="plus"]');
    this._statusEl = this.querySelector('[data-status]');
    this._errorEl = this.querySelector('[data-error]');

    this._addBtn.addEventListener('click', () => this._handleAdd());
    this._minusBtn.addEventListener('click', () => this._handleStep(-1));
    this._plusBtn.addEventListener('click', () => this._handleStep(1));

    FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartDrawerOpen,
      () => this._reset(),
    );
  }

  _reset() {
    this.removeAttribute('data-active');
    this._qty = 0;
    this._baseQty = 0;
    this._lineKey = null;
  }

  _loading(btn, on) {
    btn.disabled = on;
    btn.classList.toggle('is-loading', on);
  }

  _restoreFocus(hadFocus, target) {
    const active = document.activeElement;
    if (
      !hadFocus ||
      (active && active !== document.body && !this.contains(active))
    )
      return;
    target.focus();
  }

  _announce(el, message) {
    el.textContent = '';
    setTimeout(() => {
      el.textContent = message;
    }, 100);
  }

  _fail(message) {
    this._announce(this._errorEl, message || this.dataset.msgError);
  }

  async _handleAdd() {
    const hadFocus = this.contains(document.activeElement);
    this._loading(this._addBtn, true);
    try {
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: {sections},
        }),
      );

      const res = await fetch(FoxTheme.routes.cart_add_url, {
        ...FoxTheme.utils.fetchConfig('javascript'),
        body: JSON.stringify({
          id: this._variantId,
          quantity: 1,
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (data.status) {
        console.error(data.description);
        this._fail(data.description);
        return;
      }

      this._lineKey = data.key;
      this._baseQty = data.quantity - 1;
      this._qty = 1;
      this._addBtn.classList.remove('is-loading');
      this._addBtn.classList.add('is-success');
      await new Promise((resolve) => setTimeout(resolve, 600));
      this._addBtn.classList.remove('is-success');
      this._activateState();
      this._announce(this._statusEl, this.dataset.msgAdded);
      await this._syncCart(data.sections);
    } catch (e) {
      console.error(e);
      this._fail();
    } finally {
      this._loading(this._addBtn, false);
      this._restoreFocus(
        hadFocus,
        this.hasAttribute('data-active') ? this._plusBtn : this._addBtn,
      );
    }
  }

  async _handleStep(delta) {
    if (delta < 0 && this._qty <= 1) return;

    const btn = delta > 0 ? this._plusBtn : this._minusBtn;
    const hadFocus = this.contains(document.activeElement);
    this._loading(btn, true);
    try {
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: {sections},
        }),
      );

      const newQty = this._baseQty + this._qty + delta;
      const res = await fetch(FoxTheme.routes.cart_change_url, {
        ...FoxTheme.utils.fetchConfig(),
        body: JSON.stringify({id: this._lineKey, quantity: newQty, sections}),
      });
      const data = await res.json();
      if (data.status) {
        console.error(data.description);
        this._fail(data.description);
        return;
      }

      this._qty += delta;
      this._qtyEl.textContent = this._qty;
      this._announce(
        this._statusEl,
        `${this.dataset.msgQuantity}: ${this._qty}`,
      );
      await this._syncCart(data.sections);
    } catch (e) {
      console.error(e);
      this._fail();
    } finally {
      this._loading(btn, false);
      this._minusBtn.disabled = this._qty <= 1;
      this._restoreFocus(
        hadFocus,
        this._minusBtn.disabled ? this._plusBtn : btn,
      );
    }
  }

  _activateState() {
    this.setAttribute('data-active', '');
    this._qtyEl.textContent = this._qty;
    this._minusBtn.disabled = true;

    const compare = this.closest('.vg-product-card__buy')?.querySelector(
      '.vg-product-card__compare',
    );
    if (compare) compare.hidden = true;
  }

  async _syncCart(sections) {
    const cartJson = await fetch(
      FoxTheme.routes.cart_url,
      FoxTheme.utils.fetchConfig(),
    ).then((r) => r.json());
    if (sections) cartJson.sections = sections;
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
      cart: cartJson,
    });
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {detail: {open: false}}),
    );
  }
}

customElements.define('vg-buy-pill', VgBuyPill);
